import TalaeraBackground from "components/TalaeraBackground";
import Action from "../../components/formElements/Action/Action";
import "./UpdateInProgress.css";

type Props = {
  pingServer: () => void;
};

const UpdateInProgress = ({ pingServer }: Props) => {
  return (
    <TalaeraBackground>
      <div className="update-in-progress">
        The Talaera system is currently being upgraded. Please&nbsp;
        <Action onClick={pingServer}>check back</Action> in a few minutes.
      </div>
    </TalaeraBackground>
  );
};

export default UpdateInProgress;
